import React, { useEffect, useState } from "react";
import InputAHSF from "../../../Components/InputAHSF";
import DateInput from "../../../Components/DateInput";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import { useDispatch, useSelector } from "react-redux";
import {
  GetOneSU_NT_MRI_MainResearcherInformain,
  setMainResearcherInformain,
} from "../../../Redux/Reducers/Submitter/MainResearcherInformation";
import { decryptToken } from "../../../Services/Encryption/EncryptionParams";
import { useParams } from "react-router-dom";
import {
  GetAllSU_NT_MRI_CountryOfResidence,
  GetAllSU_ST_MRI_Governorate,
  GetAllSU_ST_MRI_GovernorateByCountry,
  GetAllSU_ST_MRI_Nationality,
} from "../../../Redux/Reducers/Submitter/MainResearcherInformation/DropDown";
import moment from "moment-timezone";

const MainResearcherInfor = (props) => {
  const [editValue, setEditValue] = useState(null);
  const [editText, setEditText] = useState(null);
  const AppGuid = useParams();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      FetchDataJson: state.FetchDataJson,
      MainResearcherInformation:
        state.MainResearcherInformation.MainResearcherInformain,
      loadingMainResearcherInformain:
        state.MainResearcherInformation.loadingMainResearcherInformain,
      DropDownSU_ST_MRI_Governorate:
        state.DropDown.DropDownSU_ST_MRI_Governorate,
      DropDownNationality: state.DropDown.DropDownNationality,
      DropDownSU_NT_MRI_CountryOfResidence: state.DropDown.DropDownSU_NT_MRI_CountryOfResidence,
      DropDownSU_ST_MRI_GovernorateByCountry: state.DropDown.DropDownSU_ST_MRI_GovernorateByCountry,
      ValidateMainResearcherPageList:
        state.MainResearcherInformation.ValidateMainResearcherPageList,
    };
  });
  console.log(state.MainResearcherInformation, "MainResearcherInformain");
  const [mainReserchInfo, setMainReserchInfo] = useState();
  const getdata = async () => {
    const data = await dispatch(
      GetOneSU_NT_MRI_MainResearcherInformain({
        applicationInformationId:
          localStorage.getItem("ApplicationInformationId") ||
          props.applicationGuid,
      })
    );
    if (data.payload) {
      setMainReserchInfo({ ...data.payload });
    }
  };
  useEffect(() => {
    getdata();
    // dispatch(GetAllSU_ST_MRI_Governorate());
    dispatch(GetAllSU_ST_MRI_Nationality());
    dispatch(GetAllSU_NT_MRI_CountryOfResidence());
  }, []);

 
  useEffect(() => {
    dispatch(setMainResearcherInformain({ ...mainReserchInfo }));
  }, [mainReserchInfo]);
 useEffect(() => {
if(state?.DropDownSU_NT_MRI_CountryOfResidence?.length>0){

  dispatch(GetAllSU_ST_MRI_GovernorateByCountry({ sU_NT_MRI_CountryOfResidenceId: mainReserchInfo?.sU_NT_MRI_CountryOfResidenceId }))
}
  }, [mainReserchInfo?.sU_NT_MRI_CountryOfResidenceId])
  console.log(
    state.MainResearcherInformation,
    "MainResearcherInformation",
    mainReserchInfo?.sU_ST_MRI_Nationality?.nationalityName
  );
console.log(mainReserchInfo,"mainReserchInfodddd");

  return !state.loadingMainResearcherInformain && mainReserchInfo ? (
    <>
      <div className="form-grid">
        <InputAHSF
          fieldsName="firstName"
          show={true}
          disabled={true}
          defaultValue={mainReserchInfo?.firstName}
        />
        <InputAHSF
          fieldsName="secondName"
          show={true}
          disabled={props.shouldDisableFields}
          defaultValue={mainReserchInfo?.fatherName}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              fatherName: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes("secondName")
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <InputAHSF
          fieldsName="therdName"
          show={true}
          disabled={props.shouldDisableFields}
          defaultValue={mainReserchInfo?.grandFatherName}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              grandFatherName: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes("therdName")
              : false
          }
        />
        <InputAHSF
          fieldsName="lastName"
          show={true}
          disabled={true}
          defaultValue={mainReserchInfo?.lastName}
        />
        <DateInput
          fieldsName="dateOfdBirth"
          list=""
          date={mainReserchInfo?.dateOfBirth}
          maxDate={moment().subtract(18, "years").format("YYYY-MM-DD")}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              dateOfBirth: e,
            });
          }}
          useFormat={true}
          disabled={props.shouldDisableFields}
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes("dateOfdBirth")
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />

        <AllDropDownsAHSF
          fieldsName="Gender"
          show={true}
          yesNo={true}
          disabled={props.shouldDisableFields}
          dropdownType="normal"
          arrayOoptionList={[
            { text: "ذكر", value: true },
            { text: "انثى", value: false },
          ]}
          KeyText={"text"}
          KeyValue={"value"}
          value={mainReserchInfo?.gender}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              gender: JSON.parse(e.target.value), // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes("Gender")
              : false
          }
          //showValidationMessage={true}
          validationMessage="يرجى تعبئة هذا الحقل"
        />

        {/* <AllDropDownsAHSF
          fieldsName="Nationality"
          hidelable={false}
          labelName={"الجنسية"}
          show={true}
          disabled={props.shouldDisableFields}
          valueEdite={mainReserchInfo?.nationalityId}
          submissionStatus={props.canEdit ? "edite" : ""}
          textEdite={
            props.canEdit ? mainReserchInfo?.nationalityName : editText
          }
          arrayOoptionList={state.DropDownNationality}
          KeyText={"nationalityName"}
          id={"nationalityId"}
          dropdownType={"search"}
          defaultValue={mainReserchInfo?.nationalityId}
          value={mainReserchInfo?.nationalityId}
          OnClickLi={(e) => {
            console.log(e, "ddeeeeeedddddddddddddd");

            setEditValue(e.nationalityId);
            setEditText(e.nationalityName);
            setMainReserchInfo({
              ...mainReserchInfo,
              nationalityId: e.nationalityId,
            });
          }}
        /> */}
        <AllDropDownsAHSF
          fieldsName="Nationality"
          hidelable={false}
          labelName={"الجنسية"}
          show={true}
          disabled={props.shouldDisableFields}
          // disabled={true}
          valueEdite={mainReserchInfo?.nationalityId}
          submissionStatus={"edite"}
          textEdite={
            mainReserchInfo?.sU_ST_MRI_Nationality?.nationalityName
          }
          arrayOoptionList={state.DropDownNationality}
          KeyText={"nationalityName"}
          id={"nationalityId"}
          dropdownType={"search"}
          defaultValue={mainReserchInfo?.nationalityId}
          value={mainReserchInfo?.nationalityId}
          OnClickLi={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              nationalityId: parseInt(e.nationalityId), // التحديث هنا
            });
            setEditValue(e.nationalityId);
            setEditText(e.nationalityName);
            // setEditValue(e.yearId);
            // setEditText(e.yearName);

          }}
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes("Nationality")
              : false
          }
          validationMessage="حقل اجباري"
        />
        {/* <AllDropDownsAHSF
          fieldsName="Nationality"
          show={true}
          disabled={props.shouldDisableFields}
          dropdownType="normal"
          arrayOoptionList={state.DropDownNationality}
          KeyText={"nationalityName"}
          KeyValue={"nationalityId"}
          defaultValue={mainReserchInfo?.nationalityId}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              nationalityId: parseInt(e.target.value), // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes("Nationality")
              : false
          }
          validationMessage="حقل اجباري"
        /> */}
        <InputAHSF
          fieldsName="CellPhoneNumber"
          show={true}
          disabled={props.shouldDisableFields}
          type={"number"}
          defaultValue={mainReserchInfo?.phoneNumber}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              phoneNumber: e.target.value, // التحديث هنا
            });
          }}
          //   showValidationMessage={
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes("CellPhoneNumber")
              : false
          }
          validationMessage="حقل اجباري"
        />

        <AllDropDownsAHSF
          fieldsName="CountryOfResidence"
          show={true}
          disabled={props.shouldDisableFields}
          dropdownType="normal"
          arrayOoptionList={state.DropDownSU_NT_MRI_CountryOfResidence}
          KeyText={"sU_NT_MRI_CountryOfResidenceName"}
          KeyValue={"sU_NT_MRI_CountryOfResidenceId"}
          defaultValue={mainReserchInfo?.sU_NT_MRI_CountryOfResidenceId}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              sU_NT_MRI_CountryOfResidenceId: parseInt(e.target.value), // التحديث هنا
              governorateId:null,
            });
          }}
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes("CountryOfResidence")
              : false
          }
        />
        
        <AllDropDownsAHSF
          fieldsName="city"
          show={true}
          disabled={props.shouldDisableFields}
          dropdownType="normal"
          arrayOoptionList={state.DropDownSU_ST_MRI_GovernorateByCountry}
          KeyText={"governorateName"}
          KeyValue={"governorateId"}
          value={mainReserchInfo?.governorateId}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              governorateId: parseInt(e.target.value), // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes("city")
              : false
          }
        />

        <InputAHSF
          fieldsName="email"
          type={"email"}
          show={true}
          disabled={true}
          defaultValue={mainReserchInfo?.emailAddress}
        />
      </div>
    </>
  ) : (
    ""
  );
};

export default MainResearcherInfor;
